import { createIconSetFromIcoMoon } from '@expo/vector-icons';
import { Icon } from '@expo/vector-icons/build/createIconSet';
import selection from 'assets/icomoon/selection.json';

export default (): Icon<string, string> => {
  return createIconSetFromIcoMoon(selection, 'billetera-fan', 'billetera-fan.ttf');
};
